export const locale = {
  'RETRANSFER' : {
    'TITLE' : 'Передача заказа',
    'MESSAGE' : 'Заказ уже передан, повторная передача отменит все предыдущие. Продолжить?',
    'CONFIRM' : 'Передать',
    'DECLINE' : 'Отмена',
  },
};
